import React, { Component } from "react";
import { Card, CardActionArea, CardContent, Typography, Grid } from "@mui/material";
import { NavLink } from "react-router-dom";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import GroupIcon from '@mui/icons-material/Group';
import ChecklistIcon from '@mui/icons-material/Checklist';
import GradingIcon from '@mui/icons-material/Grading';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import businessImg from "./images/business.png";
import businessHoverImg from "./images/businesshover.png";
import customerImg from "./images/customer.png";
import customerHoverImg from "./images/customerhover.png";
import productImg from "./images/product.png";
import productHoverImg from "./images/producthover.png";
import termsImg from "./images/terms.png";
import termsHoverImg from "./images/termshover.png";
import quotationImg from "./images/quotation.png";
import quotationHoverImg from "./images/quotationhover.png";
import quotationsecImg from "./images/quotation-2.png";
import quotationsecHoverImg from "./images/quotationhover-2.png";
import quotationthirdImg from "./images/quotation-3.png";
import quotationthirdHoverImg from "./images/quotationhover-3.png";
import quotationfourthImg from "./images/quotation-4.png";
import quotationfourthHoverImg from "./images/quotationhover-4.png";


class Dashboard extends Component {
	componentDidMount() {
    const userid = localStorage.getItem("GBuserid");

    if (!userid) {
      window.location.href = "/Businesslogin";
    }
  }
  render() {
	  
	   const userid = localStorage.getItem("GBuserid");
	  
	     console.log(window.location.pathname);
    return (
	<>
      <div className="dashboadseemain" >
	  <div className="dashboard-scroll">
     <Grid
  container
  spacing={3}
  sx={{
    flexWrap: "nowrap",
    overflowX: "auto",
    "& > *": {
      flexShrink: 0,
    },
  }}
>
          
          {/* TOP ROW */}
      

          <Grid item xs={12} sm={4}>
            <NavLink to="/Businessform" style={{ textDecoration: "none" }}>
           <Card className="business-card">
                <CardActionArea>
                  <CardContent className="dashboardasec">
				  <img
            src={businessImg}
            alt="Business"
            className="business-image business-normal"
          />

          <img
            src={businessHoverImg}
            alt="Business"
            className="business-image business-hover"
          />
                   
                  </CardContent>
                </CardActionArea>
              </Card>
			   <Typography variant="h6">Business</Typography>
            </NavLink>
          </Grid>
 <Grid item xs={12} sm={4} >
            <NavLink to="/Customerlist" style={{ textDecoration: "none" }}>
             <Card className="business-card">
                <CardActionArea>
                  <CardContent className="dashboardasec">
				      <img
            src={customerImg}
            alt="Customer"
            className="business-image business-normal"
          />

          <img
            src={customerHoverImg}
            alt="Customer"
            className="business-image business-hover"
          />
                   
                  </CardContent>
                </CardActionArea>
              </Card>
			   <Typography variant="h6">Customer</Typography>
            </NavLink>
          </Grid>
          <Grid item xs={12} sm={4}>
            <NavLink to="/Productlist" style={{ textDecoration: "none" }}>
             <Card className="business-card">
                <CardActionArea >
                  <CardContent className="dashboardasec">
                   	      <img
            src={productImg}
            alt="Product"
            className="business-image business-normal"
          />

          <img
            src={productHoverImg}
            alt="Product"
            className="business-image business-hover"
          />
                  </CardContent>
                </CardActionArea>
              </Card>
			   <Typography variant="h6">Product</Typography>
            </NavLink>
          </Grid>

          {/* BOTTOM ROW */}
          

          <Grid item xs={12} sm={4}>
            <NavLink to="/Termsandconditions" style={{ textDecoration: "none" }}>
             <Card className="business-card">
                <CardActionArea>
                  <CardContent className="dashboardasec">
                         	      <img
            src={termsImg}
            alt="Terms"
            className="business-image business-normal"
          />

          <img
            src={termsHoverImg}
            alt="Terms"
            className="business-image business-hover"
          />
                  </CardContent>
                </CardActionArea>
              </Card>
			  <Typography variant="h6">Terms</Typography>
            </NavLink>
          </Grid>

        </Grid>
      </div>
	   </div>
	  <div className="dashboadsec2" style={{ padding: "20px" }}>
	  <Grid container spacing={3}  >
          
          {/* TOP ROW */}
          <Grid item xs={12} sm={4} className="dashboarddiv">
            <NavLink to="/Makequote" style={{ textDecoration: "none" }}>
              <Card className="quotation-card">
                <CardActionArea>
                  <CardContent className="dashboardasecleft">
				                	      <img
            src={quotationImg}
            alt="Quotation"
            className="quotation-image quotation-normal"
          />

          <img
            src={quotationHoverImg}
            alt="Quotation"
            className="quotation-image quotation-hover"
          />
                   <Typography variant="h6">Make Quotation</Typography>
				   <Typography variant="h5">Create a new Quotation</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
			   
            </NavLink>
          </Grid>
		  
		    <Grid item xs={12} sm={4} className="dashboarddiv">
            <NavLink to="/Quotationlist" style={{ textDecoration: "none" }}>
           <Card className="quotation-card">
                <CardActionArea>
                  <CardContent className="dashboardasecleft">
				  	                	      <img
            src={quotationsecImg}
            alt="Quotation"
            className="quotation-image quotation-normal"
          />

          <img
            src={quotationsecHoverImg}
            alt="Quotation"
            className="quotation-image quotation-hover"
          />
                   <Typography variant="h6">Quotation List</Typography>
				   <Typography variant="h5">Manage all Quotations</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
			   
            </NavLink>
          </Grid>
		  <Grid item xs={12} sm={4} className="dashboarddiv">
            <NavLink to="/Makepurchase" style={{ textDecoration: "none" }}>
             <Card className="quotation-card">
                <CardActionArea>
                  <CardContent className="dashboardasecleft">
				  	                	      <img
            src={quotationthirdImg}
            alt="Quotation"
            className="quotation-image quotation-normal"
          />

          <img
            src={quotationthirdHoverImg}
            alt="Quotation"
            className="quotation-image quotation-hover"
          />
                   <Typography variant="h6">Make Purchase</Typography>
				   <Typography variant="h5">Create a new Puchase</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
			   
            </NavLink>
          </Grid>
		   <Grid item xs={12} sm={4} className="dashboarddiv">
            <NavLink to="/Purchaseorder" style={{ textDecoration: "none" }}>
              <Card className="quotation-card">
                <CardActionArea>
                  <CardContent className="dashboardasecleft">
				   	                	      <img
            src={quotationfourthImg}
            alt="Quotation"
            className="quotation-image quotation-normal"
          />

          <img
            src={quotationfourthHoverImg}
            alt="Quotation"
            className="quotation-image quotation-hover"
          />
                   <Typography variant="h6">Purchase Order</Typography>
				   <Typography variant="h5">Purchase Order Details</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
			   
            </NavLink>
          </Grid> 
		  
		  
		  
		    {userid !== "1" && (
  <Grid item xs={12} sm={4} className="dashboarddiv">
    <NavLink to="/Makeinvoice" style={{ textDecoration: "none" }}>
      <Card className="quotation-card">
        <CardActionArea>
          <CardContent className="dashboardasecleft">
            <img
              src={quotationImg}
              alt="Invoice"
              className="quotation-image quotation-normal"
            />

            <img
              src={quotationHoverImg}
              alt="Invoice"
              className="quotation-image quotation-hover"
            />

            <Typography variant="h6">
              Make Invoice
            </Typography>

            <Typography variant="h5">
              Create a new Invoice
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </NavLink>
  </Grid>
)}
		  
		  
		   {userid !== "1" && (
  <Grid item xs={12} sm={4} className="dashboarddiv">
    <NavLink to="/Invoicelist" style={{ textDecoration: "none" }}>
      <Card className="quotation-card">
        <CardActionArea>
          <CardContent className="dashboardasecleft">
            <img
              src={quotationsecImg}
              alt="Invoice"
              className="quotation-image quotation-normal"
            />

            <img
              src={quotationsecHoverImg}
              alt="Invoice"
              className="quotation-image quotation-hover"
            />

            <Typography variant="h6">
              Invoice List
            </Typography>

            <Typography variant="h5">
              Manage all Invoices
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </NavLink>
  </Grid>
)}
		  

		  
	   </Grid>
	  </div>
	   </>
    );
  }
}

export default Dashboard;
